import {Component, Input, ViewChild} from '@angular/core';
import {
  LigneInstanceModeleFormulaireDto,
  RechercherDossierBloqueFilterDto,
  IDossierBloqueWebServiceClient,
  PaginationDossierBloqueResultDto,
  DossierBloqueLightDto, FileProperties,
} from '@common/resources/resources';
import {AsiTableSelectionModel, AsiTableRequest, AsiTableData, AsiTable, AsiDialogService} from "@asi-ngtools/lib";
import {ModalService, NotificationService, UserStore} from "@digicerba/common";
import * as lodash from "lodash";
import {DonneesManquantesComponent} from "@utils/dialog/dialog-donnees-manquantes/donnees-manquantes-component-dialog.component";
import {EtatEnums} from "@common/enum/Etat.enum";
import {TranslateService} from "@ngx-translate/core";
import {TagsDonneesManquantes} from "@common/constants/TagsDonneesManquantes";

@Component({
  selector: 'dossier-bloques-resultats',
  templateUrl: './dossier-bloques-resultats.component.html',
})
export class DossierBloquesResultatsComponent {

  @Input() rechercherDossierBloqueFilterDto: RechercherDossierBloqueFilterDto;

  @ViewChild('instancesDataTable') instanceTable: AsiTable<LigneInstanceModeleFormulaireDto>;
  asiTableData: AsiTableData<LigneInstanceModeleFormulaireDto> = new AsiTableData<LigneInstanceModeleFormulaireDto>();
  searchHasTooManyResults: boolean;
  selectionModel = new AsiTableSelectionModel("id", false);
  currentSearchDto: RechercherDossierBloqueFilterDto;
  showCorrespondantsColumn = false;
  fileProperties: FileProperties;
  showOverlay: boolean;
  showError: boolean;

  constructor(private notificationService: NotificationService,
              private modalService: ModalService,
              private asiDialogService: AsiDialogService,
              private translateService: TranslateService,
              private userStore: UserStore,
              private dossierBloqueWebServiceClient: IDossierBloqueWebServiceClient) {
  }

  ngOnInit() {
    if(this.userStore.isAdmin()){
      this.showCorrespondantsColumn = true;
    }
    else{
      let user = this.userStore.getUser();
      if(user != null){
        let correspondants = user.correspondants;
        if(correspondants != null){
          let total = 0;
          correspondants.forEach(correspondant => {
            if(correspondant != null && correspondant.tags != null &&
              (correspondant.tags.includes(TagsDonneesManquantes.FEL_CONTRIB) || correspondant.tags.includes(TagsDonneesManquantes.FEL_GEST))){
              total ++;
            }
          })
          if(total > 1) this.showCorrespondantsColumn = true;
        }
      }
    }
    this.dossierBloqueWebServiceClient.getFileProperties().subscribe(fileProperties => {
      this.fileProperties = fileProperties;
    });
  }


  getEtatEnum(etat : string ){
    switch (etat) {
      case EtatEnums.A_VALIDER.value() : return EtatEnums.A_VALIDER ;
      case EtatEnums.EN_COURS.value() : return EtatEnums.EN_COURS ;
      default : return EtatEnums.TERMINE;
    }
  }


  openDialogDonneesManquantes(row: DossierBloqueLightDto, tab : string) {

    let asiDialog = this.asiDialogService.fromComponent(DonneesManquantesComponent, null);
    asiDialog.getComponent().numeroDossier = row.numeroDossier;
    asiDialog.getComponent().prenomNom = this.getDisplayIdentity(row.nom, row.prenom, row.nomJeuneFille);
    asiDialog.getComponent().dateDeNaissance = row.dateNaissance;
    asiDialog.getComponent().nom = this.getDisplayIdentityPdf(row.nom, row.nomJeuneFille);
    asiDialog.getComponent().prenom = row.prenom;
    asiDialog.getComponent().status = this.getEtatEnum(row.etat);
    asiDialog.getComponent().tab = tab;
    asiDialog.getComponent().fileProperties = this.fileProperties;

    asiDialog.onDialogClose().subscribe((shouldRefresh : boolean) => {
        if(shouldRefresh){
          this.rechercheDossiersBloques();
        }
    });
  }

  getDisplayIdentity(nom: String, prenom: String, nomJF: String) {
    let identity = "";
    if (nom != null && prenom != null) {
      identity = prenom + " " + nom;
      if (nomJF != null && nomJF != "") {
        identity += this.translateService.instant("PAGE.DOSSIERS_BLOQUES.neeLe");
        identity += nomJF;
      }
    }
    return identity;
  }

  getDisplayIdentityPdf(nom: String, nomJF: String) {
    let identity = "";
    if (nom != null) {
      identity = " " + nom;
      if (nomJF != null && nomJF != "") {
        identity += this.translateService.instant("PAGE.DOSSIERS_BLOQUES.neeLe");
        identity += nomJF;
      }
    }
    return identity;
  }

  refreshTable(asiTableRequest: AsiTableRequest) {
    this.currentSearchDto = {...asiTableRequest, ...this.rechercherDossierBloqueFilterDto};
    this.rechercheDossiersBloques();
  }

  ngOnChanges() {
    this.instanceTable.fireRefresh();
  }

  private rechercheDossiersBloques() {
    this.showOverlay = true;
    this.showError = false;
    this.dossierBloqueWebServiceClient.rechercheDossierBloques(this.currentSearchDto)
      .subscribe((resultats: PaginationDossierBloqueResultDto) => {
        // affichage du message si les critères de recherches sont trop larges.
        this.searchHasTooManyResults = resultats.limitExceeded;
        this.asiTableData = {...resultats.pagination, paginate: true};
        this.instanceTable.updateData(this.asiTableData);
        this.showOverlay = false;
      }, (error) => {
        if(error.status == 422){
          this.notificationService.showErrorNotification("ERRORS.unprocessable");
        }
        if (error.status == 405  || error.status == 500) {
          this.showError = true;
        }
        this.showOverlay = false;
      });
  }

  getGenericTab(row : DossierBloqueLightDto){
    return row.nombreAnomalieResultat > 0 ? 'RESULTATS' : 'DOCUMENTS';
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/pages/dossier-bloques/dossier-bloques-resultats/dossier-bloques-resultat.components.ts